export default {"src":"/_next/static/media/SnapChat.ff3fb630.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};